import BaseService from './baseService'; 

export class GetGroupOptionsService extends BaseService {
    constructor(){
        const baseUrl = "/SecurityGroups/GroupOptions/";
        super(baseUrl);
    }  
} 